const indexItems = [
  { title: '明星八卦', icon: 'ri-star-line', count: '1,286条', desc: '娱乐圈明星最新动态与花边新闻' },
  { title: '综艺爆料', icon: 'ri-tv-line', count: '892条', desc: '综艺节目幕后故事与未播出片段' },
  { title: '影视揭秘', icon: 'ri-film-line', count: '654条', desc: '电影电视剧拍摄内幕与选角消息' },
  { title: '网红圈层', icon: 'ri-live-line', count: '743条', desc: '网红主播争议事件与人设崩塌' },
  { title: '恋情曝光', icon: 'ri-heart-line', count: '521条', desc: '明星恋情、婚姻与分手最新爆料' },
  { title: '合约纠纷', icon: 'ri-file-text-line', count: '387条', desc: '艺人经纪合约与法律纠纷内幕' },
  { title: '代言风波', icon: 'ri-shopping-bag-line', count: '298条', desc: '品牌代言翻车与代言人更迭' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">内容分类索引</h2>
            <p className="text-sm text-foreground-600 mt-2">按分类发现你最感兴趣的吃瓜内容</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {indexItems.map((item, i) => (
              <a
                key={i}
                href="#carousel"
                className="flex items-start gap-4 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer group"
              >
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                  <i className={`${item.icon} text-lg text-accent-600 w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
                  <span className="inline-block mt-1.5 text-xs font-medium text-accent-600">{item.count}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}